import flagService from "./flagService.js";
import "./types.js";

/**
 * Initializes the flag service after authentication
 * @returns {Promise<void>}
 */
export function initializeFlags() {
  return flagService.initialize();
}

/**
 * Gets a specific flag - mimics useDvFlag from Nuxt 3
 * @param {ApiFlagKey} flagKey - The flag key to retrieve
 * @returns {DvFlag|null}
 */
export function useDvFlag(flagKey) {
  return flagService.getFlag(flagKey);
}

/**
 * Checks if a flag has access - mimics useDvFlagAccess from Nuxt 3
 * @param {ApiFlagKey} flagKey - The flag key to check
 * @returns {boolean}
 */
export function useDvFlagAccess(flagKey) {
  const access = flagService.hasAccess(flagKey);
  return access;
}

/**
 * Gets all flags
 * @returns {DvFlags|null}
 */
export function useAllFlags() {
  return flagService.getAllFlags();
}

/**
 * Refreshes flags from the API
 * @returns {Promise<void>}
 */
export function refreshFlags() {
  return flagService.refreshFlags();
}

/**
 * Checks if flags are currently loading
 * @returns {boolean}
 */
export function isFlagsLoading() {
  return flagService.getIsLoading();
}

// For backward compatibility and ease of use
export default {
  initializeFlags,
  useDvFlag,
  useDvFlagAccess,
  useAllFlags,
  refreshFlags,
  isFlagsLoading,
};
